import * as React from 'react';
import { createElement } from 'react';
import './index.scss';
import { getWeather } from "../../http/api";
export default class Weather extends React.PureComponent {
    state;
    props;
    setState;
    constructor(props) {
        super(props);
        this.state = {
            obj: {
                city: '',
                weather: '',
                temperature: '',
                winddirection: ''
            },
            weatherClass: "img img-",
            windpower: "无风",
            twoWeather: {
                arr: [],
                city: ''
            }
        };
    }
    componentDidMount() {
        this.getWeatherData(this.props.typeSetting);
    }
    getWeatherData = (typeSetting) => {
        getWeather({ extensions: typeSetting == 4 ? 'all' : 'base' }).then(({ resultCode, data }) => {
            if (resultCode === 200) {
                const hailArr = { "≤3": "微风", "4": "和风", "5": "清风", "6": "强风", "7": "疾风", "8": "大风", "9": "烈风", "10": "风暴", "11": "狂爆风", "12": "飓风" };
                if (typeSetting !== 4) {
                    const { weather } = data.lives[0];
                    const className = weather.indexOf('多云') !== -1 ? 'cloud' : weather.indexOf('雷雨') !== -1 ? 'thunderstorm' : weather.indexOf('暴雨') !== -1 ? 'rainstorm' : weather.indexOf('晴转雨') !== -1 ? 'sunnytorainy' : weather.indexOf('晴') !== -1 ? 'sunny' : weather.indexOf('雨夹雪') !== -1 ? 'rainplussnow' : weather.indexOf('夜') !== -1 ? 'night' : weather.indexOf('雾霾') !== -1 ? 'smog' : weather.indexOf('雷电') !== -1 ? 'thunder' : weather.indexOf('大风') !== -1 ? 'gale' : weather.indexOf('龙卷风') !== -1 ? 'tornado' : weather.indexOf('冰雹') !== -1 ? 'hail' : weather.indexOf('雨') !== -1 ? 'shower' : weather.indexOf('雪') !== -1 ? 'snow' : 'sunny';
                    this.setState(prev => ({
                        obj: data.lives[0],
                        weatherClass: prev.weatherClass + className,
                        windpower: hailArr[data.lives[0].windpower]
                    }));
                }
                else {
                    const weather = data.forecasts[0];
                    const arrFilter = weather.casts.filter((item, index) => index <= 1);
                    const arrFilter1 = arrFilter.map((item, index) => {
                        return {
                            daytemp: item.daytemp,
                            dayweather: item.dayweather,
                            daypower: hailArr[item.daypower],
                            daywind: item.daywind,
                            weatherClass: this.state.weatherClass + (item.dayweather.indexOf('多云') !== -1 ? 'cloud' : item.dayweather.indexOf('雷雨') !== -1 ? 'thunderstorm' : item.dayweather.indexOf('暴雨') !== -1 ? 'rainstorm' : item.dayweather.indexOf('晴转雨') !== -1 ? 'sunnytorainy' : item.dayweather.indexOf('晴') !== -1 ? 'sunny' : item.dayweather.indexOf('雨夹雪') !== -1 ? 'rainplussnow' : item.dayweather.indexOf('夜') !== -1 ? 'night' : item.dayweather.indexOf('雾霾') !== -1 ? 'smog' : item.dayweather.indexOf('雷电') !== -1 ? 'thunder' : item.dayweather.indexOf('大风') !== -1 ? 'gale' : item.dayweather.indexOf('龙卷风') !== -1 ? 'tornado' : item.dayweather.indexOf('冰雹') !== -1 ? 'hail' : item.dayweather.indexOf('雨') !== -1 ? 'shower' : item.dayweather.indexOf('雪') !== -1 ? 'snow' : 'sunny'),
                            day: index === 0 ? '今天' : '明天'
                        };
                    });
                    this.setState({
                        twoWeather: {
                            arr: arrFilter1,
                            city: weather.city
                        }
                    });
                }
            }
        });
    };
    componentWillReceiveProps(nextProps) {
        if (nextProps.typeSetting != this.props.typeSetting) {
            this.setState({
                weatherClass: "img img-",
            });
            this.getWeatherData(nextProps.typeSetting);
        }
    }
    render() {
        return (createElement("div", { style: { display: "inline-block" } },
            this.props.typeSetting == 1 && createElement("div", { className: "weather", style: { width: '200px', height: '100px', ...this.props.style } },
                createElement("span", null, this.state.obj.city),
                createElement("span", null, this.state.obj.weather),
                this.state.obj.temperature && createElement("span", null,
                    this.state.obj.temperature,
                    "\u2103")),
            this.props.typeSetting == 2 && createElement("div", { className: "weather", style: { width: '200px', height: '100px', ...this.props.style } },
                createElement("span", null, this.state.obj.city),
                createElement("b", { className: this.state.weatherClass }),
                this.state.obj.temperature && createElement("span", null,
                    this.state.obj.temperature,
                    "\u2103")),
            this.props.typeSetting == 3 && createElement("div", { className: "weather", style: { width: '200px', height: '100px', ...this.props.style } },
                createElement("span", null, this.state.obj.city),
                createElement("b", { className: this.state.weatherClass }),
                this.state.obj.temperature && createElement("span", null,
                    this.state.obj.temperature,
                    "\u2103"),
                createElement("span", null, this.state.windpower)),
            this.props.typeSetting === 4 && createElement("div", { className: "weather", style: { width: '300px', height: '100px', ...this.props.style } },
                createElement("div", { style: { marginRight: "10px", fontSize: "16px" } },
                    createElement("div", null, this.state.twoWeather.city)),
                this.state.twoWeather.arr.map(item => createElement("div", { className: "twoWeather" },
                    createElement("div", null,
                        createElement("b", { className: item.weatherClass, style: { marginRight: "10px" } })),
                    createElement("div", null,
                        createElement("div", null,
                            item.day,
                            item.daytemp,
                            "\u2103"),
                        createElement("div", null, item.dayweather))))),
            this.props.typeSetting == 5 && createElement("div", { className: "weather", style: { width: '200px', height: '100px', ...this.props.style } },
                createElement("div", { style: { marginRight: "10px", fontSize: "16px" } },
                    createElement("div", null, this.state.obj.city),
                    createElement("div", { style: { marginTop: "6px" } },
                        createElement("b", { className: this.state.weatherClass })),
                    createElement("div", null, this.state.obj.weather)),
                createElement("div", null,
                    createElement("div", null,
                        "\u6E29\u5EA6\uFF1A",
                        this.state.obj.temperature,
                        "\u2103"),
                    createElement("div", null,
                        "\u98CE\u529B\uFF1A",
                        this.state.windpower),
                    createElement("div", null,
                        "\u98CE\u5411\uFF1A",
                        this.state.obj.winddirection))),
            this.props.typeSetting == 6 && createElement("div", { className: "weather", style: { width: '200px', height: '100px', ...this.props.style } },
                createElement("div", { style: { marginRight: "10px" } },
                    createElement("div", { style: { fontSize: '16px' } },
                        createElement("span", null, this.state.obj.city),
                        createElement("span", { style: { color: "#FF8000" } },
                            this.state.obj.temperature,
                            "\u2103")),
                    createElement("div", null,
                        createElement("span", null, this.state.obj.weather),
                        createElement("span", null, this.state.windpower))),
                createElement("div", null,
                    createElement("b", { className: this.state.weatherClass, style: { transform: "scale(1.5, 1.5)", marginTop: "10px" } })))));
    }
}
;
